module.exports = __webpack_public_path__ + "assets/img/Type E (44).3024b84a.jpg";